// import assetPackPreload from '../../static/assets/asset-pack-preload-cartoonito.json';
import assetPackPreload from '../../static/assets/asset-pack-preload-tomandjerry.json';
import assetPackCommon from '../../static/assets/asset-pack-common.json';
import assetPackTitle from '../../static/assets/asset-pack-title.json';
import assetPackLevelSelect from '../../static/assets/asset-pack-level-select.json';
import assetPackCharacterSelect from '../../static/assets/asset-pack-character-select.json';
import assetPackGame from '../../static/assets/asset-pack-game.json';
import assetPackGame32 from '../../static/assets/asset-pack-game-32.json';
import assetPackThemeCity from '../../static/assets/asset-pack-theme-city.json';
import assetPackThemeCityAutumn from '../../static/assets/asset-pack-theme-city-autumn.json';
import assetPackThemeCityNight from '../../static/assets/asset-pack-theme-city-night.json';
import assetPackThemeCitySnow from '../../static/assets/asset-pack-theme-city-snow.json';
import assetPackThemePark from '../../static/assets/asset-pack-theme-park.json';
import assetPackThemeParkAutumn from '../../static/assets/asset-pack-theme-park-autumn.json';
import assetPackThemeParkNight from '../../static/assets/asset-pack-theme-park-night.json';
import assetPackThemeParkSnow from '../../static/assets/asset-pack-theme-park-snow.json';
import assetPackThemeParkVariant from '../../static/assets/asset-pack-theme-park-variant.json';
import { ThemeName, ThemeNameValues } from './level/themes/theme';

export const AssetPack = {
  Common: 'asset-pack-common',
  Title: 'asset-pack-title',
  Game: 'asset-pack-game',
  Game32: 'asset-pack-game-32',
  LevelSelect: 'asset-pack-level-select',
  CharacterSelect: 'asset-pack-character-select',

  ThemeCity: 'asset-pack-theme-city',
  ThemeCityAutumn: 'asset-pack-theme-city-autumn',
  ThemeCityNight: 'asset-pack-theme-city-night',
  ThemeCitySnow: 'asset-pack-theme-city-snow',
  ThemePark: 'asset-pack-theme-park',
  ThemeParkAutumn: 'asset-pack-theme-park-autumn',
  ThemeParkNight: 'asset-pack-theme-park-night',
  ThemeParkSnow: 'asset-pack-theme-park-snow',
  ThemeParkVariant: 'asset-pack-theme-park-variant'
} as const;

export const assetLookup: Map<string, any> = new Map([
  [AssetPack.Common, assetPackCommon],
  [AssetPack.Title, assetPackTitle],
  [AssetPack.Game, assetPackGame],
  [AssetPack.Game32, assetPackGame32],
  [AssetPack.LevelSelect, assetPackLevelSelect],
  [AssetPack.CharacterSelect, assetPackCharacterSelect],

  [AssetPack.ThemeCity, assetPackThemeCity],
  [AssetPack.ThemeCityAutumn, assetPackThemeCityAutumn],
  [AssetPack.ThemeCityNight, assetPackThemeCityNight],
  [AssetPack.ThemeCitySnow, assetPackThemeCitySnow],
  [AssetPack.ThemePark, assetPackThemePark],
  [AssetPack.ThemeParkAutumn, assetPackThemeParkAutumn],
  [AssetPack.ThemeParkNight, assetPackThemeParkNight],
  [AssetPack.ThemeParkSnow, assetPackThemeParkSnow],
  [AssetPack.ThemeParkVariant, assetPackThemeParkVariant]
]);

// Contains functions that return the assets to load at different bit.

export const assetsToPreload = (scene: Phaser.Scene) => {
  scene.load.pack('pack', assetPackPreload as any);
};

export const assetsToLoad = (scene: Phaser.Scene) => {
  scene.load.pack('asset-pack-common', assetPackCommon as any);
  // scene.load.pack('asset-pack-title', assetPackTitle as any);
  // scene.load.pack('asset-pack-game', assetPackGame as any);
  scene.load.pack('asset-pack-game-32', assetPackGame32 as any);
  // scene.load.pack('asset-pack-level-select', assetPackLevelSelect as any);
  // scene.load.pack('asset-pack-character-select', assetPackCharacterSelect as any);

  scene.load.spine('vehicles', 'assets/animations/vehicles.json', 'assets/animations/vehicles.atlas');
  scene.load.spine('vehicle-purple', 'assets/animations/car-purple.json', 'assets/animations/car-purple.atlas');
  scene.load.spine('vehicle-red', 'assets/animations/car-red.json', 'assets/animations/car-red.atlas');
  scene.load.spine('boost', 'assets/animations/boost.json', 'assets/animations/boost.atlas');
  scene.load.spine('effect', 'assets/animations/effect.json', 'assets/animations/effect.atlas');

  audioToLoad(scene);
};

export const gameLevelAssetsToLoad = (scene: Phaser.Scene, theme: ThemeNameValues): string[] => {
  let assetsToLoad: string[] = [];

  switch (theme) {
    case ThemeName.City:
      assetsToLoad.push(AssetPack.ThemeCity);
      // scene.load.pack('asset-pack-theme-city', assetPackThemeCity as any);
      break;
    case ThemeName.CityAutumn:
      assetsToLoad.push(AssetPack.ThemeCityAutumn);
      // scene.load.pack('asset-pack-theme-city-autumn', assetPackThemeCityAutumn as any);
      break;
    case ThemeName.CityNight:
      assetsToLoad.push(AssetPack.ThemeCityNight);
      // scene.load.pack('asset-pack-theme-city-night', assetPackThemeCityNight as any);
      break;
    case ThemeName.CitySnow:
      assetsToLoad.push(AssetPack.ThemeCitySnow);
      // scene.load.pack('asset-pack-theme-city-snow', assetPackThemeCitySnow as any);
      break;
    case ThemeName.Park:
      assetsToLoad.push(AssetPack.ThemePark);
      // scene.load.pack('asset-pack-theme-park', assetPackThemePark as any);
      break;
    case ThemeName.ParkAutumn:
      assetsToLoad.push(AssetPack.ThemeParkAutumn);
      // scene.load.pack('asset-pack-theme-park-autumn', assetPackThemeParkAutumn as any);
      break;
    case ThemeName.ParkNight:
      assetsToLoad.push(AssetPack.ThemeParkNight);
      // scene.load.pack('asset-pack-theme-park-night', assetPackThemeParkNight as any);
      break;
    case ThemeName.ParkSnow:
      assetsToLoad.push(AssetPack.ThemeParkSnow);
      // scene.load.pack('asset-pack-theme-park-snow', assetPackThemeParkSnow as any);
      break;
    case ThemeName.ParkVariant:
      assetsToLoad.push(AssetPack.ThemeParkVariant);
      // scene.load.pack('asset-pack-theme-park-variant', assetPackThemeParkVariant as any);
      break;

    default:
      break;
  }

  return assetsToLoad;
};

export const audioToLoad = (scene: Phaser.Scene) => {
  const versions = ['webm', 'm4a', 'ogg', 'mp3'];
  const addAllVersions = (fileName: string, path: string, versions: string[]): [string, string[]] => {
    let output: string[] = [];
    versions.forEach((value) => {
      output.push(`${path}${fileName}.${value}`);
    });

    return [fileName, output];
  };

  // Music
  scene.load.audio(...addAllVersions('SndGameMusicLoop', 'assets/sounds/', versions));

  // SFX
  scene.load.audio(...addAllVersions('SndItemClick', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndBeep1', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndBeep2', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndBrakes1', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndEngine1', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndEngine2', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndEngine3', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndEngine4', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndLaneChange1', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndLaneChange2', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndLaneChange3', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndPickup', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndPickup2', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndSteal1', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndSteal2', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndObstacleSplat', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndObstacleSplash1', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndObstacleSplash2', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndObstacleBox', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndObstacleSkid', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndObstacleSnow', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndObstacleRustle', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndWhistle', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndLevelLocked', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndLevelUnlock', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndSelectTom', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndSelectJerry', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndSelectSpike', 'assets/sounds/', versions));
  scene.load.audio(...addAllVersions('SndSelectToodles', 'assets/sounds/', versions));
};
